import { useEffect, useState, useContext } from "react";
import Header from "./Components/Header";
import axios from "axios";
import { base_url } from "../shared/const.prop";
import Loader from "../components/Loader";
import ProfileView from "../components/ProfileView";
import profile1 from "../img/profile-1.png";
import undrawProfile from "../img/undraw_profile.svg";
import {
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";
import VideoComponent from "../components/VideoComponent";
import UserListView from "../components/UserListView";
import NoDataAvailable from "../components/NoDataAvailable";
import { NavLink } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";

const PublicProfile = ({ id }) => {
  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [error, setError] = useState(false);
  const [otherUsers, setOtherUsers] = useState([]);
  useEffect(() => {
    fetchProfile();
  }, [id]);

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const getProfile = await axios.get(`${base_url}public-profile/${id}`);
      setUserProfile(getProfile?.data?.data);
      fetchOtherUsers();
    } catch (error) {
      if (error.response.status === 422) {
        setError(true);
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //   setLoading(false);
      setUserProfile([]);
      fetchOtherUsers();
    }
  };

  const fetchOtherUsers = async () => {
    setLoading(true);
    try {
      const getProfile = await axios.get(
        `${base_url}public-profile-users/${id}`
      );
      setOtherUsers(getProfile?.data?.data);
      setLoading(false);
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
      setOtherUsers([]);
    }
  };

  const renderMedia = () => {
    if (userProfile?.isBlockedUser) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    if (userProfile?.bannerUrl === undefined) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    if (userProfile?.bannerUrl === null) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    const fileExtension =
      userProfile?.bannerUrl &&
      userProfile?.bannerUrl.split(".").pop()?.toLowerCase();

    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={userProfile.bannerUrl}
          alt="User Banner"
          className="img-fluid postion-absolute  banner-img cursor-pointer"
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={userProfile?.bannerUrl}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img cursor-pointer"
        />
      );
    } else {
      return <VideoComponent userData={userProfile} isUserMenu={false} />;
    }
  };

  return (
    <div id="wrapper">
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <div className="landing-page-container">
            <Header isContainer={true} />
          </div>
        </div>
        <div className="container top-container">
          <div className="row">
            <div
              className={
                "col-12 col-sm-7 col-md-8 col-lg-8 public-profile-wrapper"
              }
            >
              {loading ? (
                <Loader />
              ) : error ? (
                <div className="card card-one-1">
                  <div className="card-body">
                    <p>This is not a public profile</p>
                  </div>
                </div>
              ) : (
                <div className="card card-one-1">
                  {renderMedia()}
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <div className="sme-profile">
                        <img
                          className={`img-profile rounded-circle z-circle profile-img ml-1 ${
                            userProfile?.offerService ? "sme-service" : null
                          }`}
                          src={userProfile?.picUrl || undrawProfile}
                        />
                        {userProfile?.offerService && (
                          <div
                            className="sme-profile-icon"
                            style={{ zIndex: 11, right: 0 }}
                          >
                            SME
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mt-3 mb-2">
                      <div className="col-md-7">
                        <p className="profile-name mb-0 ml-3">
                          {userProfile?.fullName || ""}{" "}
                        </p>
                      </div>
                    </div>
                    <p className="ml-3">
                      {userProfile?.headline
                        ? truncateText(userProfile?.headline, 60)
                        : ""}{" "}
                    </p>
                    <div className="boxed">
                      <div>
                        <div className="tab-pane fade show active">
                          <div className="tabbable">
                            <ul className="test-nav nav-tabs">
                              <li className="active">
                                <ProfileView
                                  type="view"
                                  viewUserData={userProfile}
                                  testData={[]}
                                  isViewPublic={true}
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 col-sm-4 col-md-4 col-lg-4 sidebar-wrapper rightSidebar-wrapper public-profile-wrapper public-side-wrapper">
              <div className="">
                <div className="card ">
                  <div className="card-body">
                    <p className="follow-txt">Suggested for you </p>
                    <>
                      {otherUsers.length === 0 ? (
                        <NoDataAvailable />
                      ) : (
                        otherUsers.map((item, index) => (
                          <div className="row mb-2" key={index}>
                            <div className="d-flex w-100 justify-content-between align-items-start">
                              <div className="col-2 col-sm-2 col-md-1">
                                <NavLink to={`../${item.userName}`}>
                                  <div className="sme-profile sme-post-profile">
                                    <img
                                      className={`img-profile rounded-circle ${
                                        item?.offerService
                                          ? "sme-mini-service"
                                          : null
                                      }`}
                                      src={item.picUrl || undrawProfile}
                                    />
                                  </div>
                                </NavLink>
                              </div>
                              <div className="col-9 col-sm-9 col-md-10 pl-4 marl">
                                <NavLink to={`../${item.userName}`}>
                                  {" "}
                                  <p>{item?.fullName} </p>
                                  {/* <p className="user-des mb-0">
                                    {item?.headline &&
                                      item?.headline.length > 0 &&
                                      concatenateAndTruncate(
                                        item?.headline,
                                        30
                                      )}
                                  </p> */}
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicProfile;
